<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Our Services</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Our Services</li>
            </ul>
        </div>
    </div>
</div>

<section class="position-relative bg-top-center mt-auto mt-md-2 overflow-hidden space" id="service-sec">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="title-area service-title-box text-center">
                    <span class="sub-title mb-15  text-anime-style-2">Empowering Your Business with Innovative IT
                        Solutions</span>
                    <h2 class="sec-title  text-anime-style-3">Dealing in all professional IT services</h2>
                    <p class="sec-text mb-50 wow fadeInUp" data-wow-delay=".3s">IT solutions refer to a broad range of
                        services and technologies designed to address <br> specific business needs, streamline
                        operations, and drive growth.</p>
                </div>
            </div>
        </div>
        <div class="service-area">
            <div class="row gy-30 justify-content-center">

                <div class="col-xl-3 col-md-6">
                    <div class="service-box service-style-1">
                        <div class="service-img">
                            <a routerLink="/website-development">
                                <img src="assets/img/service/sv-2.jpg" alt="Web Development" />
                            </a>
                        </div>
                        <div class="service-content">
                            <h3 class="box-title">
                                <a routerLink="/website-development">Web Development</a>
                            </h3>
                            <p class="service-box_text">We build fast, modern, and scalable web development solutions.
                            </p>
                            <a class="th-btn style4" routerLink="/website-development">
                                Read More <i class="fa-light fa-arrow-right-long"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-6">
                    <div class="service-box service-style-1">
                        <div class="service-img">
                            <a routerLink="/design">
                                <img src="assets/img/service/sv-1.jpg" alt="UX/UI Design" />
                            </a>
                        </div>
                        <div class="service-content">
                            <h3 class="box-title">
                                <a routerLink="/design">UX/UI Design</a>
                            </h3>
                            <p class="service-box_text">Crafting seamless, intuitive interfaces for exceptional user
                                experiences.</p>
                            <a class="th-btn style4" routerLink="/design">
                                Read More <i class="fa-light fa-arrow-right-long"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-6">
                    <div class="service-box service-style-1">
                        <div class="service-img">
                            <a routerLink="/mobile-development">
                                <img src="assets/img/service/sv-3.jpg" alt="App Development" />
                            </a>
                        </div>
                        <div class="service-content">
                            <h3 class="box-title">
                                <a routerLink="/mobile-development">App Development</a>
                            </h3>
                            <p class="service-box_text">Custom web applications tailored to streamline your business and
                                growth.</p>
                            <a class="th-btn style4" routerLink="/mobile-development">
                                Read More <i class="fa-light fa-arrow-right-long"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-6">
                    <div class="service-box service-style-1">
                        <div class="service-img">
                            <a routerLink="/ai-assisted-integrations">
                                <img src="assets/img/service/sv-4.jpg" alt="AI Assisted Integrations" />
                            </a>
                        </div>
                        <div class="service-content">
                            <h3 class="box-title">
                                <a routerLink="/ai-assisted-integrations">AI Assisted Integrations</a>
                            </h3>
                            <p class="service-box_text">AI Assisted Integrations streamline workflows with smart,
                                automated
                                connectivity solutions.</p>
                            <a class="th-btn style4" routerLink="/ai-assisted-integrations">
                                Read More <i class="fa-light fa-arrow-right-long"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-6">
                    <div class="service-box service-style-1">
                        <div class="service-img">
                            <a routerLink="/seo-services">
                                <img src="assets/img/service/sv-5.jpg" alt="SEO Services" />
                            </a>
                        </div>
                        <div class="service-content">
                            <h3 class="box-title">
                                <a routerLink="/seo-services">SEO Services</a>
                            </h3>
                            <p class="service-box_text">Boost your online visibility with expert SEO services today.</p>
                            <a class="th-btn style4" routerLink="/seo-services">
                                Read More <i class="fa-light fa-arrow-right-long"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-6">
                    <div class="service-box service-style-1">
                        <div class="service-img">
                            <a routerLink="/maintenance-and-updates">
                                <img src="assets/img/service/sv-6.jpg" alt="Maintenance and Updates" />
                            </a>
                        </div>
                        <div class="service-content">
                            <h3 class="box-title">
                                <a routerLink="/maintenance-and-updates">Maintenance and Updates</a>
                            </h3>
                            <p class="service-box_text">Regular maintenance ensures performance, security, and smooth
                                user
                                experience.</p>
                            <a class="th-btn style4" routerLink="/maintenance-and-updates">
                                Read More <i class="fa-light fa-arrow-right-long"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-6">
                    <div class="service-box service-style-1">
                        <div class="service-img">
                            <a routerLink="/ios-development">
                                <img src="assets/img/service/sv-7.jpg" alt="iOS Development" />
                            </a>
                        </div>
                        <div class="service-content">
                            <h3 class="box-title">
                                <a routerLink="/ios-development">iOS Development</a>
                            </h3>
                            <p class="service-box_text">Expert iOS development delivering sleek, secure,
                                high-performance mobile
                                apps.</p>
                            <a class="th-btn style4" routerLink="/ios-development">
                                Read More <i class="fa-light fa-arrow-right-long"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-6">
                    <div class="service-box service-style-1">
                        <div class="service-img">
                            <a routerLink="/logo-design">
                                <img src="assets/img/service/sv-8.jpg" alt="Logo Design" />
                            </a>
                        </div>
                        <div class="service-content">
                            <h3 class="box-title">
                                <a routerLink="/logo-design">Logo Design</a>
                            </h3>
                            <p class="service-box_text">Professional logo design tailored to elevate your brand
                                identity.</p>
                            <a class="th-btn style4" routerLink="/logo-design">
                                Read More <i class="fa-light fa-arrow-right-long"></i>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>

<!--======== Our Process Section ========-->
<app-our-process></app-our-process>

<!--======== Footer Section ========-->
<app-footer></app-footer>